import { Button, Tooltip } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { isOperator } from '../../../../../../services/AccountService'
import { openModalFn } from '../../../../../../utils/controllers/ModalController'

interface ToGuaranteeRepairProps {
  currentServiceData: any
  setOnSiteDrawerType: (type: string) => void
}

const ToGuaranteeRepair: FC<ToGuaranteeRepairProps> = ({
  currentServiceData,
  setOnSiteDrawerType,
}) => {
  const handleAction = () => {
    setOnSiteDrawerType && setOnSiteDrawerType('to-guarantee-repair')
    isOperator()
      ? openModalFn['operator-to-guarantee-drawer']?.()
      : openModalFn['on-site-service-drawer']?.()
  }

  const disableByOperator =
    isOperator() &&
    currentServiceData?.incidentTypeId !== 'Неисправность по вине производителя'

  const disabled =
    disableByOperator || (!isOperator() && !currentServiceData.equipmentId)

  return (
    <Tooltip
      title='Тип инцидента не соответствует гарантийному ремонту.'
      placement='top'
      disableHoverListener={!disableByOperator}
    >
      <div>
        <Button
          onClick={handleAction}
          fullWidth
          variant='contained'
          disabled={disabled}
        >
          требуется гарантийный ремонт
        </Button>
      </div>
    </Tooltip>
  )
}

export default observer(ToGuaranteeRepair)
